export default "__VITE_ASSET__DlZMNBqh__"